"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getButtonClass;
function getButtonClass(version) {
  return "button button--".concat(version);
}